import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Box } from '@mui/material';
import { FormSelectField, FormTextField } from 'ui';
import { consumer } from '@tock/coretypes';
import protos from 'utils/protos';

export interface CardLinkWidgetFields extends BaseWidgetFormFields {
  imageUrl: string;
  imageAlt: string;
  tagline: string;
  linkText: string;
  linkHref: string;
  variant: consumer.CardLinkWidget.CardLinkVariant;
}

const { CardLinkWidget } = protos;

const variantDisplayNameMap: {
  [K in consumer.CardLinkWidget.CardLinkVariant]: string;
} = {
  DEFAULT: 'Default',
  LARGE: 'Large',
};

const allVariantOptions = Object.keys(
  CardLinkWidget.CardLinkVariant
) as consumer.CardLinkWidget.CardLinkVariant[];

const variantOptions = allVariantOptions.map((variant) => {
  return {
    key: variant,
    label: variantDisplayNameMap[variant],
    value: variant,
  };
});

export const CardLinkWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <FormTextField id="imageUrl" name="imageUrl" label="Image URL" fullWidth />
      <FormTextField id="imageAlt" name="imageAlt" label="Image alt text" fullWidth />
      <FormTextField id="tagline" name="tagline" label="Tagline" fullWidth />
      <FormTextField id="linkText" name="linkText" label="Link text" fullWidth />
      <FormTextField id="linkHref" name="linkHref" label="Link href" fullWidth />
      <FormSelectField id="variant" name="variant" label="Variant">
        {variantOptions.map(({ key, value, label }) => {
          return <option key={key} value={value} label={label} />;
        })}
      </FormSelectField>
    </Box>
  );
};
